<template>
  <div class="chart-container flex justify-center items-center flex-col">
    <v-chart
      v-if="!isLoading"
      :options="chartOptions"
      :autoresize="true"
      ref="chart"
      class="rounded-lg border border-gray-200"
    ></v-chart>
    <div v-else class="skeleton-chart">
      <div class="skeleton-bar" v-for="n in 4" :key="n"></div>
    </div>
    <div class="w-full" v-if="legend && !isLoading">
      <span class="text-left italic">{{ legend }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericPieChart',
  props: {
    value: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    legend: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: this.title,
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#434343',
          },
        },
        series: [
          {
            name: 'Percentage',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [
              {
                value: this.value,
                name: 'Completed',
              },
              {
                value: 100 - this.value,
                name: 'Remaining',
              },
            ],
            label: {
              show: true,
              position: 'inside',
              formatter: '{d}%',
              color: '#fff',
              fontWeight: 'bold',
            },
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 1,
            },
          },
        ],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.updateChart(newValue);
      },
    },
  },
  methods: {
    updateChart(value) {
      try {
        this.chartOptions.series[0].data = [
          { value: value, name: 'Completed', itemStyle: { color: '#0F4173' } },
          {
            value: 100 - value,
            name: 'Remaining',
            itemStyle: { color: '#C8283C' },
          },
        ];
        if (!this.$refs.chart) {
          console.warn('Chart reference is not available.');
          return;
        }
        this.$refs.chart.setOption(this.chartOptions);
      } catch (error) {
        console.error('Error updating chart:', error);
      }
    },
    resizeChart() {
      if (this.$refs.chart) {
        this.$refs.chart.resize();
      }
    },
  },
  mounted() {
    this.resizeChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  padding: 16px;
}
.skeleton-chart {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}
.skeleton-bar {
  background-color: #e0e0e0;
  height: 32px;
  border-radius: 5px;
  margin: 8px 0;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
